<script setup lang="ts">
import NewsCard from '@features/news/components/NewsCard/NewsCard.vue'

import { useNewsDetailPage } from '@features/news/composables/useNewsDetailPage'
import { NEWS_FALLBACK_TITLE } from '@features/news/constants'
import { createNewsDetailSeo } from '@features/news/services/createNewsDetailSeo'
import { createSeoHead } from '@shared/nuxt/createSeoHead'

const route = useRoute()
const { $host } = useNuxtApp()

const { news, breadcrumbs } = await useNewsDetailPage()

const titleName = news.value?.title ?? NEWS_FALLBACK_TITLE
const { title, description } = createNewsDetailSeo(titleName)

useHead({
  title,
  ...createSeoHead(
    $host,
    {
      title,
      keywords: '',
      description,
    },
    route.fullPath,
    route.path,
  ),
})
</script>

<template>
  <div class="news-page">
    <the-breadcrumbs
      class="news-page__breadcrumbs"
      theme="dark"
      :breadcrumbs="breadcrumbs"
      :domain="$host"
    />

    <news-card v-if="news" :news="news" layout="full" />
  </div>
</template>

<style lang="scss" scoped>
.news-page {
  padding: 45px 20px 0;

  &__breadcrumbs {
    margin-top: 39px;
    margin-bottom: 40px;
  }

  @include media($bp-tablet) {
    padding: 80px 48px 0;
  }

  @include media($bp-desktop-mini) {
    padding: 80px 0 120px 0; // 80 отступ сверху, 120 отступ снизу
  }
}
</style>
